<script setup>
import axios  from "axios";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-dialog
    v-model="product_flg"
    width="500px"

>
    <v-card>
    <v-toolbar
      dense
      flat
      tite
      height="60px"
      class="pb-2"
      color="#E13533"
      dark
      z-index="1000000"
    >
        <v-toolbar-title>
            商材情報管理
        </v-toolbar-title>
        <v-spacer>
        </v-spacer>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-on="on"
                v-bind="attrs"
                class="mr-3"
                @click="view_list_mode"
            >
                    mdi-format-list-bulleted
            </v-icon>
            </template>
            <span>一覧表示</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-on="on"
                v-bind="attrs"
                class="mr-3"
                @click="add"
            >
                mdi-card-plus-outline
            </v-icon>
            </template>
            <span>新規追加</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-on="on"
                v-bind="attrs"
                class="mr-3"
                @click="product_flg=false"
            >
                mdi-close
            </v-icon>
            </template>
            <span>閉じる</span>
        </v-tooltip>
    </v-toolbar>
    <v-card-subtitle>
    </v-card-subtitle>

    <v-card-text 
        class="pb-1"
        v-if="product_mode==true"
    >
        <v-radio-group
          v-model="selected_product_id"
          column
        >

        <v-list>
            <v-list-item
                v-for="item in product_list"
                v-bind:key="item.id"
                class="pt-0 pb-0 pr-0 pl-0"
                min-height="12px"
            >
                <v-card 
                    width="100%"
                    class="mb-2"
                >
                    <v-card-text
                        class="pt-0 pb-0 pr-0 pl-0"
                    >
                        <v-container>
                            <v-row>
                            <v-col
                                class="pr-0"
                                cols = "1"
                            >
                            <v-radio
                                color="red"
                                :value="item.id"
                                @click="set_product_data"
                            ></v-radio>
                            </v-col>
                            <v-col 
                                class="pr-0 product_list_title_box"
                            cols="9">
                            <span>{{ item.product_name }}</span>
                            </v-col>
                            <v-col
                                class="pl-0 pr-0"
                            >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    class="mr-3"
                                    :id="item.id"
                                    @click="del"
                                >
                                    mdi-delete
                                </v-icon>
                                </template>
                                <span>削除</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    class="mr-3"
                                    :id="item.id"
                                    @click="product_edit"
                                >
                                    mdi-pencil
                                </v-icon>
                                </template>
                                <span>編集</span>
                            </v-tooltip>
                            </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-list-item>
        </v-list>
        </v-radio-group>
    </v-card-text>
    <v-card-text 
        class="pb-1"
        v-if="product_mode==false"
    >
        <span v-if="product_list.length==0" class="zero_message"><v-icon color="blue" class="mr-2">mdi-information-outline</v-icon>プレスリリースで扱う商材の説明、分類やAI作成で利用します。</span>
        <v-text-field
              clearable
              placeholder="商材の名称"
              hide-details="auto"
              v-model="product_name"
              :value = "product_name"
              class="mb-2"
              dense
              outlined
        ></v-text-field>
        <v-textarea
              clearable
              placeholder="商材の簡単な説明"
              hide-details="auto"
              v-model="product_summary"
              :value = "product_summary"
              dense
              class="mb-2"
              outlined
        ></v-textarea>
    </v-card-text>
    <v-card-actions class="pb-3" v-if="product_mode==false">
        <v-spacer>
        </v-spacer>
        <v-btn
            @click="product_flg=false"
        >
            cancel
        </v-btn>
        <v-btn
            @click="product_save"
            :disabled="product_save_flg"
        >
            保存
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>
<script>
export default {
    watch : {
		product_flg : function(){
			if(this.product_flg==true)
				this.product_load();
		},
        product_mode : function(){
            if(this.product_mode == true)
            {
                this.product_load();
            }
        },
		store_product_list : function(){
			this.product_load();
		},
		input_query : function(){
			if(this.product_name != "" && this.product_summary != "" && this.product_name != null && this.product_summary != null)
				this.product_save_flg = false;
			else
				this.product_save_flg = true;
		},
    },
	computed : {
        store_product_list : function(){
            return this.$store.getters['product_list/get_product'];
        },
        loaded : function(){
			return this.$store.getters['product_list/get_load'];
		},
		input_query : function(){
			return [this.product_name,this.product_summary];
		},
	},
    data : function(){
        return {
            product_flg      : false,
            product_mode     : true,
			product_list     : [],
            product_save_flg : true,
            selected_product_id : null,
            selected_product : null,
            id : null,
            product_name : "",
            product_summary: "",
        };
    },
    methods : {
		product_load(){
			this.product_list = this.store_product_list;
			if(this.store_product_list.length==0)
				this.product_mode=false;
		},
        add   : function(){
            this.product_mode=false;
            this.product_name = "";
            this.product_summary = "";
            this.id = null;
            this.selected_product_id = null;
        },
		add_open : function(){
            this.product_mode=false;
            this.product_name = "";
            this.product_summary = "";
            this.id = null;
            this.selected_product_id = null;
            this.product_flg=true;
		},
        open : function(){
            this.product_flg=true;
        },
		selected_open(pid){
			this.selected_product_id = pid;
			this.set_product_data();
            this.product_flg=true;
		},
        product_save : async function(){
            var params = new URLSearchParams();
            params.append("product_name",this.product_name);
            params.append("product_summary",this.product_summary);
            params.append("id",this.id);
            await axios.post("https://qlipper.jp/api/gpt/set_product",params)
            .then(response => {
				this.$store.commit("product_list/set_product_list",response.data.list);
				this.$store.commit("doc_info/set_product_id",response.data.id);
				this.selected_product_id = response.data.id;
                this.product_mode = true;
            });
        },
        view_list_mode : function(){
            this.product_mode=true;
        },
        get_product : function(id){
            let index = 0;
            if(id==0)return index;
            for(;index<this.product_list.length;index++)
            {
                if(this.product_list[index].id == id)
                {
                    break;
                }
            }
            return index;
        },
        set_product_data : function(){
            this.selected_product = this.product_list[this.get_product(this.selected_product_id)];
            this.$emit("setproduct",{"id":this.selected_product_id});
        },
        product_edit : function(event){
            this.product_mode=false;
            let index = this.get_product(event.target.id);
            this.product_name=this.product_list[index].product_name;
            this.product_summary=this.product_list[index].product_summary;
            this.id=this.product_list[index].id;
        },
        del : async function(event){
            if(event.target.id == this.selected_product_id)
            {
                if(!window.confirm("IDが選択されています。削除してよろしいですか？"))
                {
                    return false;
                }
            }

            var params = new URLSearchParams();
            params.append("id",event.target.id);
            await axios.post("/api/gpt/del_product",params)
            .then(response => {
                //this.product_list  = response.data;
				this.$store.commit("product_list/set_product_list",response.data);
            });

        },
    },
}
</script>
<style>
.product_list_title_box{
    display : flex;
    align-items   :center;
}
.zero_message{
	color : black;
	margin: 10px 0;
	display : block;
}
</style>
